module.exports = __webpack_public_path__ + "static/img/server12.9431faa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/server12.png
// module id = qhAX
// module chunks = 1